import { useOffline } from "@/context/OfflineContext";
import { WifiOff, RefreshCw, CloudUpload } from "lucide-react";

// Slim status pill shown only when offline or while there are unsynced entries.
// Positioned below the mobile header / near the top on desktop so it never
// disrupts the page layout.
export const OfflineBanner = () => {
  const { isOnline, pendingCount, syncing } = useOffline();

  if (isOnline && pendingCount === 0 && !syncing) return null;

  let tone = "bg-amber-500 text-white";
  let Icon = WifiOff;
  let text = "Offline – Änderungen werden lokal gespeichert";

  if (!isOnline) {
    text =
      pendingCount > 0
        ? `Offline – ${pendingCount} ${pendingCount === 1 ? "Eintrag" : "Einträge"} lokal gespeichert`
        : "Offline – Änderungen werden lokal gespeichert";
  } else if (syncing) {
    tone = "bg-blue-600 text-white";
    Icon = RefreshCw;
    text = "Synchronisiere ausstehende Einträge …";
  } else if (pendingCount > 0) {
    tone = "bg-blue-600 text-white";
    Icon = CloudUpload;
    text = `${pendingCount} ${pendingCount === 1 ? "Eintrag wartet" : "Einträge warten"} auf Synchronisierung`;
  }

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 top-[4.5rem] lg:top-3 z-[60] pointer-events-none"
      data-testid="offline-banner"
    >
      <div
        className={`flex items-center gap-2 rounded-full px-4 py-2 text-xs sm:text-sm font-medium shadow-lg ${tone}`}
        data-testid="offline-banner-pill"
      >
        <Icon className={`w-4 h-4 shrink-0 ${syncing ? "animate-spin" : ""}`} />
        <span>{text}</span>
      </div>
    </div>
  );
};

export default OfflineBanner;
